import iconVisual from '../../assets/images/sessionResult/cognitive/icon-visual.svg';
import iconMemory from '../../assets/images/sessionResult/cognitive/icon-memory.svg';
import iconReasoning from '../../assets/images/sessionResult/cognitive/icon-reasoning.svg';
import medal from '../../assets/images/sessionResult/cognitive/medal.svg';
import footprints from '../../assets/images/sessionResult/cognitive/footprints.svg';

type IconProps = { className?: string };

/** Figma 71:113 — 시각적 탐색 (30×30) */
export function CognitiveIconVisualSearch({ className }: IconProps) {
  return (
    <img
      src={iconVisual}
      alt=""
      width={30}
      height={30}
      className={className}
      aria-hidden
    />
  );
}

/** Figma 71:113 — 기억력 (29×30) */
export function CognitiveIconMemory({ className }: IconProps) {
  return (
    <img
      src={iconMemory}
      alt=""
      width={29}
      height={30}
      className={className}
      aria-hidden
    />
  );
}

/** Figma 71:113 — 추론 (23×30) */
export function CognitiveIconReasoning({ className }: IconProps) {
  return (
    <img
      src={iconReasoning}
      alt=""
      width={23}
      height={30}
      className={className}
      aria-hidden
    />
  );
}

/** Figma 77:227 — 메달 (50×70) */
export function CognitiveMedalDecoration({ className }: { className?: string }) {
  return (
    <img src={medal} alt="" width={50} height={70} className={className} aria-hidden />
  );
}

/** Figma 77:245 — 발자국 (61×68) */
export function CognitiveFootprintsDecoration({ className }: { className?: string }) {
  return (
    <img
      src={footprints}
      alt=""
      width={61}
      height={68}
      className={className}
      aria-hidden
    />
  );
}
